import React, { useState } from "react";
import { Briefcase, BarChart3, Layers, Bot, LayoutDashboard, MonitorSmartphone } from "lucide-react";
import { Link } from "react-router-dom";

const services = [
  {
    key: "webAppDevelopment",
    icon: <Briefcase size={28} />,
    title: "Web App Development",
    description: "Build modern, responsive web applications with cutting-edge technology.",
  },
  {
    key: "interactiveDesign",
    icon: <BarChart3 size={28} />,
    title: "Interactive Design",
    description: "Create engaging, user-friendly designs for websites and apps.",
  },
  {
    key: "aiAutomation",
    icon: <Bot size={28} />,
    title: "AI Automation",
    description: "Implement AI-powered automation to streamline processes and increase efficiency.",
  },
  {
    key: "erpConsulting",
    icon: <Layers size={28} />,
    title: "ERP Consulting",
    description: "Expert advice and implementation for ERP solutions to optimize business operations.",
  },
  {
    key: "processAutomation",
    icon: <MonitorSmartphone size={28} />,
    title: "Process Automation",
    description: "Automate routine tasks and workflows with intelligent process automation solutions.",
  },
  {
    key: "cloudSolutions",
    icon: <LayoutDashboard size={28} />,
    title: "Cloud Solutions",
    description: "Leverage scalable cloud-based solutions to enhance business agility and efficiency.",
  },
];

const Services = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const handleTouch = (index) => {
    setHoveredIndex(index === hoveredIndex ? null : index);
  };

  return (
    <section className="hero-pattern-dots bg-white dark:bg-slate-900 py-6 sm:py-8 lg:py-12 transition-colors duration-300">
      <div className="mx-auto max-w-screen-2xl px-4 md:px-8">
        {/* Text Section */}
        <div className="mb-10 md:mb-16">
          <h2 className="mb-4 text-center text-2xl font-bold text-textDark dark:text-textLight md:mb-6 lg:text-3xl">
            Transform Your Business
          </h2>
          <p className="mx-auto max-w-screen-md text-center text-gray-500 dark:text-gray-300 md:text-lg">
            At Blackbear Technologies, we provide custom solutions that enhance efficiency, boost productivity, and drive growth. Our expertise in AI, automation, data analytics, and ERP solutions helps businesses thrive and stay competitive. Let us guide you on your digital transformation journey today.
          </p>
        </div>

        {/* Services Cards */}
        <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-3">
          {services.map((service, index) => {
            const isActive = hoveredIndex === index;

            return (
              <div
                key={service.key}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                onClick={() => handleTouch(index)}
                onTouchStart={() => handleTouch(index)}
                className={`
                  flex flex-col rounded-lg border p-4 md:p-6 transition-all duration-300
                  bg-white dark:bg-slate-900
                  border-gray-200 dark:border-slate-700
                  ${isActive
                    ? "bg-gray-100 dark:bg-slate-800 text-blue-700 dark:text-blue-400 shadow-lg"
                    : "text-textDark dark:text-textLight hover:bg-gray-50 dark:hover:bg-slate-800 hover:shadow-lg"
                  }
                `}
                style={{ minHeight: 270 }}
              >
                <div className={`mb-4 transition-colors duration-300 ${isActive ? "text-blue-700 dark:text-blue-400" : "text-gray-700 dark:text-gray-200"}`}>
                  {service.icon}
                </div>
                <h3 className="mb-2 text-lg font-semibold md:text-xl">{service.title}</h3>
                <p className="mb-4 text-gray-500 dark:text-gray-300">{service.description}</p>
                <Link
                  to="/contact"
                  className="mt-auto font-bold text-blue-700 dark:text-blue-400 transition duration-100 hover:text-indigo-600 dark:hover:text-indigo-400 active:text-indigo-700"
                  tabIndex={0}
                >
                  More
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
